export default function getHeaders() {
  return {
    "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
  }
}